export default __webpack_public_path__ + "41262b5c8c06163a98b3f0b55f2ae994.png";